// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__frDry","option":"styles_option__Ow2TK","active":"styles_active__3wRny"};